/**
 * 說明 : 角色權限與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import {createAsyncThunk} from '@reduxjs/toolkit';

// ----- import from Base API -----
import BaseAPI from './BaseAPI';

// 新增角色權限
export const addRolePermission = createAsyncThunk(
  'rolePermission/addRolePermission',
  async (rolePermission, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/setting/rolePermission', rolePermission, token);
      return data;
    } catch (err) {
      console.error('add role permission error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改角色權限
export const editRolePermission = createAsyncThunk(
  'rolePermission/editRolePermission',
  async (rolePermission, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/rolePermission', rolePermission, token);
      return data;
    } catch (err) {
      console.error('edit role permission error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 刪除角色權限
export const deleteRolePermission = createAsyncThunk(
  'rolePermission/deleteRolePermission',
  async (permissionIds, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.deleteWithAuth(`/setting/rolePermission/${permissionIds}`, null, token);
      return data;
    } catch (err) {
      console.error('delete role permission error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得單筆角色權限資料
export const fetchRolePermission = createAsyncThunk(
  'rolePermission/fetchRolePermission',
  async (permissionId, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(`/setting/rolePermission/${permissionId}`, null, token);
      return data;
    } catch (err) {
      console.error('fetch role permission error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得角色權限清單列表
export const fetchRolePermissionList = createAsyncThunk(
  'rolePermission/fetchRolePermissionList',
  async ({roleId, moduleId}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/setting/rolePermission', {roleId: roleId, moduleId: moduleId}, token);
      return data;
    } catch (err) {
      console.error('fetch rolePermission list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
